import { CRM_API, RequestHelper } from "utils";

const RUTA = "seguridad";
export const SeguridadService = (() => {
  const listarLogsAuditoria = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(`${RUTA}/ListarLogsAuditoria`, params);
    });
  };

  const exportarLogsAuditoria = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).post(`${RUTA}/exportarLogsAuditoria`, params, true);
    });
  };

  const buscarLogAuditoria = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(`${RUTA}/BuscarLogAuditoria`, params);
    });
  };

  const buscarCompania = function () {
    return new Promise((res) => res()).then(() => {
      return RequestHelper(CRM_API).get(`${RUTA}/BuscarCompania`);
    });
  };

  return { listarLogsAuditoria, exportarLogsAuditoria, buscarLogAuditoria, buscarCompania };
})();
